
import React, { useEffect, useState } from 'react';
import Header from '../../Core/Header';
import { Section } from '../../Core/Section';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  assignServicePerson,
  getServiceBoyList,
  getServiceRequestHandler,
  storeTypeList
} from '../../Services/Operations/ProductAPI';
import { toast } from 'react-toastify';
import { baseURL } from '../../Services/api_endpoints';


const AssignServicePerson = () => {
  const navigate = useNavigate();
  const token = useSelector((state) => state.user.token);

  const [serviceBoys, setServiceBoys] = useState([]);
  const [requestService, setRequestSerice] = useState([]);
  const [modal, setModal] = useState(null);
  const [serviceId, setServiceId] = useState('');
  const [checkoutId, setCheckoutId] = useState('');
  const [images, setImages] = useState(null);
  const [currentimg, setCurrentimg] = useState('');
  const [storeModal, setStoreModal] = useState(false);
  const [storeOwner, setStoreOwner] = useState([]);
  const [currentStore, setCurrentStore] = useState(null);

  const fetchServiceRequest = async () => {
    try {
      const response = await getServiceRequestHandler(token);
      console.log(response);

      if (response.status === 200) {
        setRequestSerice(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchServieBoys = async () => {
    if (!token) {
      navigate('/login');
      return;
    }

    try {
      const response = await getServiceBoyList(token);
      console.log('serice boy List: ', response);
      setServiceBoys(response);
    } catch (error) {
      console.log(error);
    }
  };

  const handleAssignServicePerson = async (input) => {
    console.log(input);

    let data = {
      servicePersonCommonuserId: input.commonId,
      servicePersonId: input.personId,
      checkoutId: checkoutId,
      serviceRequestId: serviceId,
      storeOwnerId: currentStore
    };

    console.log(data);

    try {
      const response = await assignServicePerson(token, data);
      console.log(response);

      if (response.status === 200) {
        toast.success('service person assigned');
        setModal(null);
        fetchServiceRequest();
      }
    } catch (error) {
      toast.error('failed to asssign this person');
      console.log(error);
    }
  };

  const fetchStoreOwner = async () => {
    try {
      const response = await storeTypeList(token);
      console.log(response);
      setStoreOwner(response);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    fetchServiceRequest();
    fetchServieBoys();
    fetchStoreOwner();
  }, []);

  const pendingCount = requestService.filter(
    (item) => item.serviceStatus === 'PENDING'
  ).length;

  const assignedCount = requestService.length - pendingCount;

  return (
    <div id="main_content">
      <Header />

      <div className="page">
        <Section />

        <div className="asp-page">

          {/* Page Heading */}
          <div className="asp-heading">
            <div>
              <div className="asp-breadcrumb">
                <span>Dashboard</span>
                <i className="fa fa-angle-right" />
                <span>Service Management</span>
              </div>

              <h2>Service Requests</h2>

              <p>
                Manage pickup requests and assign service personnel to each order.
              </p>
            </div>

            <div className="asp-heading-icon">
              <i className="fa fa-truck" />
            </div>
          </div>

          {/* Summary Cards */}
          <div className="asp-stats">

            <div className="asp-stat-card">
              <div className="asp-stat-icon asp-red">
                <i className="fa fa-clipboard-list" />
              </div>
              <div>
                <span>Total Requests</span>
                <h3>{requestService.length}</h3>
                <small>All service requests</small>
              </div>
            </div>

            <div className="asp-stat-card">
              <div className="asp-stat-icon asp-orange">
                <i className="fa fa-clock" />
              </div>
              <div>
                <span>Pending Requests</span>
                <h3>{pendingCount}</h3>
                <small>Awaiting assignment</small>
              </div>
            </div>

            <div className="asp-stat-card">
              <div className="asp-stat-icon asp-green">
                <i className="fa fa-check-circle" />
              </div>
              <div>
                <span>Assigned Requests</span>
                <h3>{assignedCount}</h3>
                <small>Already processed</small>
              </div>
            </div>

            <div className="asp-stat-card">
              <div className="asp-stat-icon asp-blue">
                <i className="fa fa-users" />
              </div>
              <div>
                <span>Service Personnel</span>
                <h3>{serviceBoys.length}</h3>
                <small>Available personnel list</small>
              </div>
            </div>

          </div>

          {/* Main Content */}
          <div className="asp-content">

            <div className="asp-content-header">
              <div>
                <h3>
                  <i className="fa fa-list-alt" />
                  Pickup Requests
                </h3>
                <p>Review request information and manage assignments.</p>
              </div>

              <div className="asp-total-badge">
                {requestService.length} Requests
              </div>
            </div>

            {/* Selected Store Indicator */}
            <div className="asp-store-bar">
              <div className="asp-store-info">
                <div className="asp-store-icon">
                  <i className="fa fa-store" />
                </div>

                <div>
                  <strong>Assignment Store</strong>
                  <p>
                    {currentStore
                      ? storeOwner.find(
                          (st) => st.storeOwnerId === currentStore
                        )?.storeName || 'Selected store'
                      : 'No store selected'}
                  </p>
                </div>
              </div>

              <button
                className="asp-select-store"
                onClick={() => setStoreModal(true)}
              >
                <i className="fa fa-map-marker-alt" />
                {currentStore ? 'Change Store' : 'Select Store'}
              </button>
            </div>

            {/* Table */}
            <div className="asp-table-container">
              {requestService.length > 0 ? (
                <div className="asp-table-scroll">
                  <table className="asp-table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Checkout</th>
                        <th>Product</th>
                        <th>Serial Number</th>
                        <th>Images</th>
                        <th>Status</th>
                        <th>Pickup Date</th>
                        <th>Location</th>
                        <th>Contact</th>
                        <th>Store</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {requestService.map((item, index) => (
                        <tr key={item.id || index}>
                          <td>
                            <span className="asp-id">#{item?.id}</span>
                          </td>

                          <td>
                            <span className="asp-checkout-id">
                              {item?.checkoutId}
                            </span>
                          </td>

                          <td>
                            <span className="asp-product-id">
                              {item?.productId}
                            </span>
                          </td>

                          <td>
                            <span className="asp-serial">
                              {item?.serialNumber || '—'}
                            </span>
                          </td>

                          <td>
                            <button
                              className="asp-image-button"
                              onClick={() => {
                                setImages(item?.productImages);
                                setCurrentimg(item?.productImages[0]);
                              }}
                            >
                              <i className="fa fa-images" />
                              Images
                              <span>{item?.productImages.length}</span>
                            </button>
                          </td>

                          <td>
                            <span
                              className={`asp-status ${
                                item.serviceStatus === 'PENDING'
                                  ? 'asp-status-pending'
                                  : 'asp-status-done'
                              }`}
                            >
                              <span className="asp-status-dot" />
                              {item?.serviceStatus}
                            </span>
                          </td>

                          <td>
                            <div className="asp-date">
                              <i className="fa fa-calendar-alt" />
                              {item?.pickupDateTime}
                            </div>
                          </td>

                          <td>
                            <div className="asp-location">
                              <i className="fa fa-map-marker-alt" />
                              {item?.pickupLocation}
                            </div>
                          </td>

                          <td>
                            <span className="asp-contact">
                              <i className="fa fa-phone" />
                              {item?.alternateNumber}
                            </span>
                          </td>

                          <td>
                            <button
                              className="asp-store-cell"
                              onClick={() => setStoreModal(true)}
                            >
                              <i className="fa fa-store" />
                              {currentStore
                                ? storeOwner.find(
                                    (st) => st.storeOwnerId === currentStore
                                  )?.storeName || 'Selected'
                                : 'Select'}
                            </button>
                          </td>

                          <td>
                            {item.serviceStatus === 'PENDING' ? (
                              <button
                                className="asp-assign-button"
                                onClick={() => {
                                  if (!currentStore) {
                                    toast.info('select a store to proceed');
                                    return;
                                  }

                                  setModal(item.id);
                                  setCheckoutId(item.checkoutId);
                                  setServiceId(item.id);
                                }}
                              >
                                <i className="fa fa-user-plus" />
                                Assign
                              </button>
                            ) : (
                              <button
                                className="asp-done-button"
                                onClick={() => {
                                  alert('This service already assigned');
                                }}
                              >
                                <i className="fa fa-check" />
                                Done
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="asp-empty">
                  <div className="asp-empty-icon">
                    <i className="fa fa-inbox" />
                  </div>
                  <h3>No service requests found</h3>
                  <p>Service requests will appear here when available.</p>
                </div>
              )}
            </div>
          </div>

          {/* Assign Service Person Modal */}
          {modal && (
            <div
              className="asp-overlay"
              onClick={() => setModal(null)}
            >
              <div
                className="asp-modal asp-person-modal"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="asp-modal-header">
                  <div className="asp-modal-title-icon">
                    <i className="fa fa-user-plus" />
                  </div>

                  <div>
                    <h3>Assign Service Person</h3>
                    <p>Select a person for this pickup request.</p>
                  </div>

                  <button
                    className="asp-close"
                    onClick={() => setModal(null)}
                  >
                    <i className="fa fa-times" />
                  </button>
                </div>

                <div className="asp-modal-body">
                  <div className="asp-modal-section-label">
                    Available Service Personnel
                    <span>{serviceBoys.length} Members</span>
                  </div>

                  {serviceBoys.length > 0 ? (
                    <div className="asp-person-list">
                      {serviceBoys.map((person, index) => (
                        <div
                          className="asp-person-card"
                          key={person.employeeId || index}
                        >
                          <div className="asp-person-avatar">
                            {person.firstName?.charAt(0)?.toUpperCase() || 'S'}
                          </div>

                          <div className="asp-person-details">
                            <h4>{person.firstName}</h4>
                            <p>
                              <i className="fa fa-map-marker-alt" />
                              {person.areaLocalitySector || 'Area not available'}
                            </p>
                            <p>
                              <i className="fa fa-location-arrow" />
                              Pincode: {person.pincode || '—'}
                            </p>
                          </div>

                          <button
                            className="asp-person-assign"
                            onClick={() =>
                              handleAssignServicePerson({
                                commonId: person.commonuserId,
                                personId: person.employeeId
                              })
                            }
                          >
                            Assign
                            <i className="fa fa-arrow-right" />
                          </button>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="asp-modal-empty">
                      <i className="fa fa-users" />
                      <p>No service personnel available.</p>
                    </div>
                  )}
                </div>

                <div className="asp-modal-footer">
                  <button
                    className="asp-cancel-button"
                    onClick={() => setModal(null)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Product Image Gallery */}
          {images && (
            <div
              className="asp-overlay asp-gallery-overlay"
              onClick={() => {
                setImages(null);
                setCurrentimg('');
              }}
            >
              <div
                className="asp-gallery-modal"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="asp-modal-header">
                  <div className="asp-modal-title-icon">
                    <i className="fa fa-images" />
                  </div>

                  <div>
                    <h3>Product Images</h3>
                    <p>{images.length} images available</p>
                  </div>

                  <button
                    className="asp-close"
                    onClick={() => {
                      setImages(null);
                      setCurrentimg('');
                    }}
                  >
                    <i className="fa fa-times" />
                  </button>
                </div>

                <div className="asp-gallery-main">
                  {currentimg && (
                    <img
                      src={baseURL + 'api' + currentimg}
                      alt="Selected product"
                    />
                  )}
                </div>

                <div className="asp-gallery-thumbnails">
                  {images.map((img, index) => (
                    <button
                      key={index}
                      className={`asp-thumbnail ${
                        currentimg === img ? 'asp-thumbnail-active' : ''
                      }`}
                      onClick={() => setCurrentimg(img)}
                    >
                      <img
                        src={baseURL + 'api' + img}
                        alt={`Product ${index + 1}`}
                      />
                    </button>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Store Selection Modal */}
          {storeModal && (
            <div
              className="asp-overlay asp-store-overlay"
              onClick={() => setStoreModal(false)}
            >
              <div
                className="asp-modal asp-store-modal"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="asp-modal-header">
                  <div className="asp-modal-title-icon">
                    <i className="fa fa-store" />
                  </div>

                  <div>
                    <h3>Available Stores</h3>
                    <p>Select a store for service assignment.</p>
                  </div>

                  <button
                    className="asp-close"
                    onClick={() => setStoreModal(false)}
                  >
                    <i className="fa fa-times" />
                  </button>
                </div>

                <div className="asp-modal-body">
                  {storeOwner.length > 0 ? (
                    <div className="asp-store-list">
                      {storeOwner.map((st) => (
                        <div
                          className={`asp-store-card ${
                            currentStore === st.storeOwnerId
                              ? 'asp-store-selected'
                              : ''
                          }`}
                          key={st.storeOwnerId}
                        >
                          <div className="asp-store-card-icon">
                            <i className="fa fa-store" />
                          </div>

                          <div className="asp-store-card-details">
                            <h4>{st.storeName}</h4>
                            <p>
                              <span>Store ID:</span> {st.storeOwnerId}
                            </p>
                            <p>
                              <span>GST:</span> {st.storeOwnerGstNumber}
                            </p>
                            <p>
                              <i className="fa fa-map-marker-alt" />
                              {st.storeAddress}
                            </p>
                          </div>

                          {currentStore !== st.storeOwnerId ? (
                            <button
                              className="asp-store-add"
                              onClick={() => setCurrentStore(st.storeOwnerId)}
                            >
                              <i className="fa fa-plus" />
                              Select
                            </button>
                          ) : (
                            <button
                              className="asp-store-remove"
                              onClick={() => setCurrentStore(null)}
                            >
                              <i className="fa fa-check" />
                              Selected
                            </button>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="asp-modal-empty">
                      <i className="fa fa-store" />
                      <p>No stores available.</p>
                    </div>
                  )}
                </div>

                <div className="asp-modal-footer">
                  <button
                    className="asp-cancel-button"
                    onClick={() => setStoreModal(false)}
                  >
                    Close
                  </button>

                  <button
                    className="asp-confirm-button"
                    onClick={() => setStoreModal(false)}
                    disabled={!currentStore}
                  >
                    <i className="fa fa-check" />
                    Confirm Store
                  </button>
                </div>
              </div>
            </div>
          )}

        </div>

        {/* Footer */}
        <div className="section-body">
          <footer className="footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025{' '}
                  <a href="">
                    Technology support By - Siance Software Pvt Ltd
                  </a>
                  .
                </div>
              </div>
            </div>
          </footer>
        </div>

      </div>
    </div>
  );
};

export default AssignServicePerson;
